import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-183691c8"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]

import { computed, ref } from 'vue'
import HeaderLoginArea from './modules/loginArea.vue'
import { useRouter } from 'vue-router'

// Reactive window width

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const windowWidth = ref(window.innerWidth)

// Update window width on resize
const updateWindowWidth = () => {
  windowWidth.value = window.innerWidth
}
window.addEventListener('resize', updateWindowWidth)

const logoSrc = computed(() => {
  return windowWidth.value < 768
    ? require('@/assets/images/common/icon.png') // Narrow screen logo
    : require('@/assets/images/login/signlogo.png') // Default logo
})

const router = useRouter()
const activeIndex = ref('home')

const menuItems = [
  {
    index: '1',
    label: '课例',
    route: '/course'
  },
  {
    index: '2',
    label: '试卷',
    route: '/paper'
  },
  {
    index: '3',
    label: '配图',
    route: '/paper-res'
  },
  {
    index: '4',
    label: '试题',
    route: '/question'
  },
  {
    index: '5',
    label: '解析',
    route: '/resolve'
  },
  {
    index: '6',
    label: '会议',
    route: '/meeting'
  },
]

function navigate (nav: string) {
  const item = menuItems.find(item => item.index === nav)
  if (item) {
    activeIndex.value = nav
    router.push({ path: item.route })
  } else {
    console.warn(`No route found for menu index: ${nav}`)
  }
}

function handleSelect (key: string) {
  navigate(key)
}

return (_ctx: any,_cache: any) => {
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_menu = _resolveComponent("el-menu")!

  return (_openBlock(), _createBlock(_component_el_menu, {
    "default-active": activeIndex.value,
    ellipsis: false,
    class: "el-menu-container",
    mode: "horizontal",
    onSelect: handleSelect
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_menu_item, {
        class: "logo-item",
        index: "logo",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push('/home')))
      }, {
        default: _withCtx(() => [
          _createElementVNode("img", {
            src: logoSrc.value,
            alt: "课·视频Logo",
            class: "logo"
          }, null, 8, _hoisted_1)
        ]),
        _: 1
      }),
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(menuItems, (item) => {
        return _createVNode(_component_el_menu_item, {
          key: item.index,
          class: "menu-item",
          onClick: ($event: any) => (navigate(item.index))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(item.label), 1)
          ]),
          _: 2
        }, 1032, ["onClick"])
      }), 64)),
      _createVNode(_component_el_menu_item, {
        class: "menu-item",
        index: "user"
      }, {
        default: _withCtx(() => [
          _createVNode(HeaderLoginArea)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["default-active"]))
}
}

})